import { useCallback, useState } from 'react';
import { useDebounce } from './useDebounce';

export function useSearchLoading(initialSearch: string, debounceMs = 500) {
  const [search, setSearchDirect] = useState(initialSearch);
  const [loading, setLoading] = useState(true);
  const debouncedSearch = useDebounce(search, debounceMs);

  const setSearch = useCallback(
    (next: string) => {
      if (next.length > 200) {
        return;
      }
      if (next.trim() !== search.trim()) {
        setLoading(true);
      }
      setSearchDirect(next);
    },
    [search]
  );

  const effectiveLoading = loading || search.trim() !== debouncedSearch.trim();

  return {
    search,
    debouncedSearch,
    setSearch,
    setSearchDirect,
    loading,
    setLoading,
    effectiveLoading,
  };
}
